import { useState, useEffect } from 'react';

/**
 * Custom hook for LinkedIn Deepdive metrics
 * Tracks connections, followers, profile views, searches, and SSI
 */
export const useLinkedIn = (dateRange) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (isRefresh = false) => {
    if (isRefresh) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }
    setError(null);

    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 800));

      // Mock data for LinkedIn metrics
      const mockData = {
        metrics: {
          connections: 4850,
          followers: 12450,
          profileViews: 2340,
          searches: 892,
          ssi: 78, // Social Selling Index (0-100)
        },
        changes: {
          connections: 5.2,
          followers: 8.5,
          profileViews: 12.3,
          searches: 15.7,
          ssi: 3.2,
        },
        ssiBreakdown: {
          establishBrand: 82, // out of 25
          findRightPeople: 76, // out of 25
          engageInsights: 75, // out of 25
          buildRelationships: 79, // out of 25
        },
        monthlyTrend: [
          { month: 'Jan', connections: 4620, followers: 11480, profileViews: 2100, searches: 765, ssi: 75 },
          { month: 'Feb', connections: 4690, followers: 11720, profileViews: 2180, searches: 812, ssi: 76 },
          { month: 'Mar', connections: 4770, followers: 12050, profileViews: 2260, searches: 848, ssi: 77 },
          { month: 'Apr', connections: 4850, followers: 12450, profileViews: 2340, searches: 892, ssi: 78 },
        ],
      };

      setData(mockData);
    } catch (err) {
      setError(err.message || 'Failed to fetch LinkedIn data');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dateRange]);

  const refetch = () => fetchData(true);

  return {
    data,
    loading,
    refreshing,
    error,
    refetch,
  };
};